import styled from 'styled-components';
import { Menu } from '@mui/material';
import { theme } from '../../styles/theme';
export const Wrapper = styled(Menu) `
  .MuiPaper-root {
    box-shadow: ${theme.mixins.shadowLight};
    border: 1px solid ${theme.colors.borderDark};
    border-radius: ${theme.spacing.xs};
    padding: 0;
  }

  .MuiList-root {
    padding: 0;
  }
`;
